import { any, instanceOf, number, string, oneOfType } from "prop-types"

export const date = oneOfType([
    any,
    instanceOf(Date),
    number,
    string,
])